'use client'

import Script from 'next/script'
import React from 'react'
import { useCookieConsent } from '@/global/hooks/useCookieConsent'

const HUBSPOT_KEY = process.env.NEXT_PUBLIC_APP_HUBSPOT_KEY
const HUBSPOT_CONSENT_CATEGORY = 'targeting'

export const AppScripts = () => {
  const consentGranted = useCookieConsent(HUBSPOT_CONSENT_CATEGORY)

  if (!consentGranted) {
    return null
  }

  return (
    <>
      {/* HubSpot */}
      <Script
        id='hubspot'
        strategy='lazyOnload'
        src={`//js.hs-scripts.com/${HUBSPOT_KEY}.js`}
      />
    </>
  )
}
